import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["micro", "label", "numeric-md", "numeric-lg", "numeric-xl"] },
      ],
      shadow: [{ shadow: ["raised", "popover", "modal"] }],
      rounded: [{ rounded: ["pill", "control"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
